module.exports = __webpack_public_path__ + "img/1509873023.4edeba88.jpg";